import { render, staticRenderFns } from "./TabAssociacoes.vue?vue&type=template&id=adc466c0"
import script from "./TabAssociacoes.vue?vue&type=script&lang=ts"
export * from "./TabAssociacoes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports